import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class GetDataService {
  constructor(private http: HttpClient) { }

  private apiUrl = environment.apiUrl;

  getData() {
    return this.http.get<any>(`${this.apiUrl}/Rules/Contents`, environment.options);
  }

  getDataById(id: any) {
    return this.http.get<any>(`${this.apiUrl}/Rules/GetContentByID?ID=${id}`, environment.options);
  }

  getVersions() {
    return this.http.get<any>(`${this.apiUrl}/Rules/Versions`, environment.options);
  }

  addData(request: any, userName: string, Id: number) {
    const params = new HttpParams();
    params.set('user',userName)
    params.set('id',Id)
    return this.http.post(`${this.apiUrl}/Rules/Addcontent?user=${userName}&id=${Id}`, request, environment.options);
  }

  getExportedPDF(v: string) {
    return this.http.get(`${this.apiUrl}/PdfDocuments/export-pdf?version=${v}`, {
      responseType: 'blob',
      headers: {
        "Ngrok-Skip-Browser-Warning": "true",
        "Accept": "application/pdf"
      }
    });
  }

  uploadPDF(file: File) {
    const formData = new FormData();
    formData.append("file", file, file.name)
    return this.http.post(`${this.apiUrl}/PdfDocuments/upload-pdf`, formData)
  }

  getBotResponse(userMessage: any) {
    return this.http.post<any>(`${this.apiUrl}/Chat/GetResponse`, {
      userMessage: userMessage
    }, environment.options)
  }

  addConfiguration(body: any) {
    return this.http.post<any>(`${this.apiUrl}/SystemFlags/AddFlag`, body, environment.options)
  }

  updateConfiguration(body: any, id: number) {

    return this.http.put<any>(`${this.apiUrl}/SystemFlags/UpdateFlag?id=${id}`, body, environment.options)
  }

  getConfiguration() {
    return this.http.get<any>(`${this.apiUrl}/SystemFlags/GetFlags`, environment.options);
  }

  getComparedResponse(newfile: File) {
    const formData = new FormData();
    formData.append("file", newfile, newfile.name)
    return this.http.post(`${this.apiUrl}/Compare/CompareDocument`, formData)
  }
}
